import GroupIcon from '@mui/icons-material/Group';
import BarChartIcon from '@mui/icons-material/BarChart';
import { style } from 'constant/constants';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { isAdmin, isUser } from 'utils/utils';

const styles = { color: style.LIGHT.primary, fontFamily: style.fontFamily };

const commonIcons = [
  {
    name: 'Prices',
    icon: <MonetizationOnIcon style={styles} />,
    path: '/StoreInfo/prices'
  }
];

const adminIcons = [
  {
    name: 'Projects',
    icon: <BarChartIcon style={styles} />,
    path: '/StoreInfo/projects'
  },
  {
    name: 'Users',
    icon: <GroupIcon style={styles} />,
    path: '/StoreInfo/users'
  },
  ...commonIcons
];

const userIcons = [
  {
    name: 'Projects',
    icon: <BarChartIcon style={styles} />,
    path: '/StoreInfo/projects'
  },
  ...commonIcons
];

export const roleBasedIcons = (role) => {
  if (isAdmin(role)) {
    return adminIcons;
  }
  if (isUser(role)) {
    return userIcons;
  }
};

export const roleBasedDrawerWidth = (role) => {
  if (isAdmin(role) || isUser(role)) {
    return 250;
  } else return 0;
};
